var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"height":"300px"},attrs:{"id":'chartdiv' + _vm.type}})])}
var staticRenderFns = []

export { render, staticRenderFns }